module.exports = __webpack_public_path__ + "images/Sundial_Growers-ecc7de.png";